import script from "./AddressComponent.vue?vue&type=script&lang=ts&setup=true&async=true"
export * from "./AddressComponent.vue?vue&type=script&lang=ts&setup=true&async=true"

const __exports__ = script;

export default __exports__